(() => {
  if (customElements.get('cuppy-product-size-guide')) return;
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  class ProductSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-guide-labels]').textContent);
      const storedChart = window.CUPPY_SIZE_CHARTS?.[this.dataset.product];
      this.chart = storedChart ? { ...storedChart, ...storedChart.productGuide } : null;
      this.system = 'EU';
      this.units = 'cm';
      this.content = this.querySelector('[data-guide-content]');
      if (!this.chart) { this.content.textContent = this.labels.missing; return; }
      this.render();
      // Shrine moves each modal to body. Remove stale instances after cart/section refresh.
      queueMicrotask(() => {
        const modal = this.closest('modal-dialog');
        document.querySelectorAll('modal-dialog.cuppy-guide-modal').forEach(other => {
          if (other !== modal && other.id === modal.id) {
            if (other.hasAttribute('open')) other.hide();
            other.remove();
          }
        });
      });
    }
    render() {
      const l = this.labels, c = this.chart, id = this.dataset.guideId;
      const singlePanel = ['high-panty','sculpt-leggings'].includes(this.dataset.product);
      const tabs = el('div','cuppy-guide-tabs');
      tabs.setAttribute('role','tablist');
      tabs.setAttribute('aria-label',c.kind === 'bra' ? l.bra : l.body);
      if (!singlePanel) this.content.append(tabs);
      const tablePanel = el('div'), measuringPanel = el('div');
      const panels = [tablePanel,measuringPanel];
      const tabButtons = [c.kind === 'bra' ? l.bra : l.body,c.bodyRows ? l.body : l.measure].map((name,i) => {
        const button = el('button','cuppy-guide-tab',name);
        button.type = 'button'; button.id = id+'-tab-'+i;
        button.setAttribute('role','tab'); button.setAttribute('aria-controls',id+'-panel-'+i);
        panels[i].id = id+'-panel-'+i;
        panels[i].setAttribute('role','tabpanel'); panels[i].setAttribute('aria-labelledby',button.id);
        const select = () => tabButtons.forEach((tab,j) => {
          tab.setAttribute('aria-selected',String(i === j)); tab.tabIndex = i === j ? 0 : -1;
          panels[j].hidden = i !== j;
        });
        button.addEventListener('click',select);
        button.addEventListener('keydown',event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1-i;
          tabButtons[next].click(); tabButtons[next].focus();
        });
        tabs.append(button); return button;
      });
      tabButtons[0].setAttribute('aria-selected','true'); tabButtons[1].setAttribute('aria-selected','false');
      tabButtons[1].tabIndex = -1; measuringPanel.hidden = true;
      if (singlePanel) {
        tablePanel.removeAttribute('role');
        tablePanel.removeAttribute('aria-labelledby');
        this.content.append(tablePanel);
      } else this.content.append(...panels);
      if (c.kind !== 'dress') {
        const converter = el('div','cuppy-guide-converter');
        converter.append(el('span','',c.kind === 'bra' ? l.system : l.units));
        const group = el('div','cuppy-guide-units'); group.setAttribute('role','group');
        group.setAttribute('aria-label',c.kind === 'bra' ? l.system : l.units);
        const options = c.kind === 'bra' ? [['EU','EU'],['US','US']] : [['cm',l.cm],['inch',l.inch]];
        for(const [value,label] of options) {
          const button = el('button','',label); button.type = 'button';
          button.setAttribute('aria-pressed',String(value === options[0][0]));
          button.addEventListener('click',() => {
            if(c.kind === 'bra') this.system = value; else this.units = value;
            group.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
            this.renderTable();
          });
          group.append(button);
        }
        converter.append(group); tablePanel.append(converter);
      }
      this.table = el('table','cuppy-guide-table'); tablePanel.append(this.table); this.renderTable();
      if(c.kind === 'bra') tablePanel.append(el('p','cuppy-guide-note',l.bra_help));
      if(!singlePanel && c.rows.some(r => /[-/]/.test(r.size))) tablePanel.append(el('p','cuppy-guide-note',l.shared));
      if (!singlePanel && !c.supplied) tablePanel.append(el('p','cuppy-guide-note',c.planned ? l.planned : l.reference));
      const fields = c.kind === 'bra' ? ['underbust','bust'] : c.fields || (this.dataset.product === 'bikini-top' ? ['underbust','bust'] : ['waist','hips']);
      if (c.bodyRows) {
        const bodyTable = el('table','cuppy-guide-table'), head = el('thead'), headRow = el('tr'), body = el('tbody');
        [l.size,l.underbust+' ('+l.cm+')',l.bust+' ('+l.cm+')'].forEach(label => {
          const th = el('th','',label); th.scope = 'col'; headRow.append(th);
        });
        head.append(headRow);
        c.bodyRows.forEach(row => {
          const tr = el('tr'), th = el('th','',row.size); th.scope = 'row'; tr.append(th);
          ['underbust','bust'].forEach(field => {
            const td = el('td'); td.append(el('span','cuppy-guide-range',row[field].map(Math.round).join('–'))); tr.append(td);
          });
          body.append(tr);
        });
        bodyTable.append(head,body); measuringPanel.append(bodyTable);
      }
      if (!singlePanel) this.addMeasuring(measuringPanel,fields,true);
      this.addMeasuring(tablePanel,fields,singlePanel);
    }
    renderTable() {
      const c = this.chart, l = this.labels;
      this.table.replaceChildren();
      const thead = el('thead'), header = el('tr'); thead.append(header);
      const columns = c.kind === 'bra' ? [l.size,l.your_bra+' ('+this.system+')'] : c.kind === 'dress' ? [l.size,l.dress] : [l.size,...c.fields.map(f => l[f]+' ('+l[this.units]+')')];
      columns.forEach(label => { const th = el('th','',label); th.scope = 'col'; header.append(th); });
      this.table.setAttribute('aria-label',columns.slice(1).join(', '));
      const tbody = el('tbody'); this.table.append(thead,tbody);
      const rows = c.kind === 'bra' ? [...new Set(c.rows.map(r => r.size))].map(size => ({size,cups:c.rows.filter(r => r.size === size)})) : c.rows;
      for(const row of rows) {
        const tr = el('tr'), th = el('th','',row.size); th.scope = 'row'; tr.append(th);
        if(c.kind === 'bra') {
          const td = el('td'), cups = el('div','cuppy-guide-cups');
          row.cups.forEach(r => {
            const band = this.system === 'EU' ? r.band*2.5-10 : r.band;
            const cup = this.system === 'EU' ? ({DD:'E',E:'E','DD/E':'E',DDD:'F',F:'F','DDD/F':'F',G:'G'}[r.cup] || r.cup) : ({E:'DD',F:'DDD','DD/E':'DD','DDD/F':'DDD'}[r.cup] || r.cup);
            cups.append(el('span','',String(band)+cup));
          });
          td.append(cups); tr.append(td);
        } else {
          const fields = c.kind === 'dress' ? ['dress'] : c.fields;
          fields.forEach(f => {
            const range = row[f].map(v => c.kind === 'dress' || this.units === 'inch' ? v : Math.round(v*2.54));
            const td = el('td'); td.append(el('span','cuppy-guide-range',range.join('–'))); tr.append(td);
          });
        }
        tbody.append(tr);
      }
    }
    addMeasuring(parent,fields,detailed) {
      const section = el('section','cuppy-guide-how');
      section.append(el('h3','cuppy-guide-how-title',this.labels.measure_heading));
      const grid = el('div','cuppy-guide-measurements');
      fields.forEach(field => {
        const figure = el('figure'), picture = el('div','cuppy-guide-picture cuppy-guide-picture--'+field,'\u00a0');
        picture.setAttribute('role','img'); picture.setAttribute('aria-label',this.labels[field+'_help']);
        figure.append(picture,el('figcaption','',this.labels[field]));
        if(detailed) figure.append(el('p','cuppy-guide-instruction',this.labels[field+'_help']));
        grid.append(figure);
      });
      section.append(grid);
      parent.append(section);
    }
  }
  // Let Shrine's button handler open its modal, then stop the upsell container toggle.
  class SizeGuideLink extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready = true;
      this.addEventListener('click',event => event.stopPropagation());
    }
  }
  customElements.define('cuppy-product-size-guide',ProductSizeGuide);
  customElements.define('cuppy-size-guide-link',SizeGuideLink);
  document.body.addEventListener('modalClosed',() => queueMicrotask(() => {
    const drawer = document.querySelector('cart-drawer.active');
    if(drawer && !document.querySelector('modal-dialog[open]')) {
      document.body.classList.add('overflow-hidden');
      if(typeof window.trapFocus === 'function') window.trapFocus(drawer,document.activeElement);
    }
  }));
})();
